import {
  LoadReasonsAction,
  LoadReasonsSuccessAction,
  LoadReasonsErrorAction,
  LoadConversionAction,
  LoadConversionSuccessAction,
  LoadConversionErrorAction,
  InitiateConversionAction,
  InitiateConversionSuccessAction,
  InitiateConversionErrorAction,
  DeclineConversionAction,
  DeclineConversionSuccessAction,
  DeclineConversionErrorAction,
  ClearStoreAction,
} from './actions.d';
import actionTypes from './actionTypes';
import {
  ILoadPredefinedReasonsPayload,
  ILoadConversionPayload,
  IInitiateConversionPayload,
  IDeclineConversionPayload,
  ILoadReasonsSuccessPayload,
  ILoadConversionSuccessPayload,
  IConversionMutationSuccessPayload,
} from '../types';

const actions = {
  loadReasons: (payload: ILoadPredefinedReasonsPayload): LoadReasonsAction => ({
    type: actionTypes.LOAD_REASONS,
    payload,
  }),
  loadReasonsSuccess: (payload: ILoadReasonsSuccessPayload): LoadReasonsSuccessAction => ({
    type: actionTypes.LOAD_REASONS_SUCCESS,
    payload,
  }),
  loadReasonsError: (): LoadReasonsErrorAction => ({
    type: actionTypes.LOAD_REASONS_ERROR,
  }),
  loadConversion: (payload: ILoadConversionPayload): LoadConversionAction => ({
    type: actionTypes.LOAD_CONVERSION,
    payload,
  }),
  loadConversionSuccess: (payload: ILoadConversionSuccessPayload): LoadConversionSuccessAction => ({
    type: actionTypes.LOAD_CONVERSION_SUCCESS,
    payload,
  }),
  loadConversionError: (): LoadConversionErrorAction => ({
    type: actionTypes.LOAD_CONVERSION_ERROR,
  }),
  initiateConversion: (payload: IInitiateConversionPayload): InitiateConversionAction => ({
    type: actionTypes.INITIATE_CONVERSION,
    payload,
  }),
  initiateConversionSuccess: (payload: IConversionMutationSuccessPayload): InitiateConversionSuccessAction => ({
    type: actionTypes.INITIATE_CONVERSION_SUCCESS,
    payload,
  }),
  initiateConversionError: (): InitiateConversionErrorAction => ({
    type: actionTypes.INITIATE_CONVERSION_ERROR,
  }),
  declineConversion: (payload: IDeclineConversionPayload): DeclineConversionAction => ({
    type: actionTypes.DECLINE_CONVERSION,
    payload,
  }),
  declineConversionSuccess: (payload: IConversionMutationSuccessPayload): DeclineConversionSuccessAction => ({
    type: actionTypes.DECLINE_CONVERSION_SUCCESS,
    payload,
  }),
  declineConversionError: (): DeclineConversionErrorAction => ({
    type: actionTypes.DECLINE_CONVERSION_ERROR,
  }),
  clearStore: (): ClearStoreAction => ({
    type: actionTypes.CLEAR_STORE,
  }),
};

export default actions;
